export default __webpack_public_path__ + "static/media/photo_gallery_11.b5e2c125.png";